/**
 * Mirrors the prototype's `.card` / `.ch` / `.cb`. The header is transparent
 * (not filled) and its title is sentence-case at 12.5px — the uppercase
 * micro-label treatment belongs to field labels, not card headers.
 */
.card {
  margin-bottom: var(--sp-6);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  background: var(--surf);
  overflow: hidden;
  transition:
    background var(--transition),
    border-color var(--transition);
}
.flush {
  margin-bottom: 0;
}

.header {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  padding: var(--sp-5) var(--sp-6);
  border-bottom: 1px solid var(--line);
}

.title {
  display: flex;
  align-items: center;
  gap: 7px;
  color: var(--text);
  font-size: 12.5px;
  font-weight: 700;
}

.actions {
  display: flex;
  gap: var(--sp-3);
  align-items: center;
  margin-left: auto;
}

.body {
  padding: var(--sp-6);
}
.bodyFlush {
  padding: 0;
}
